import React from "react";
import { Link } from "react-router-dom";

export const Navigation = () => {
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container-fluid">
        <div className="navbar-header d-flex align-items-center">
          <Link
            to="/"
            className="navbar-brand"
            style={{ display: "flex", alignItems: "center" }}
          >
            <img
              src="/img/airbox/abx_barra.png"
              alt="Logo"
              style={{
                height: "150%",   // 🔹 ocupa toda la altura del contenedor
                width: "auto",    // 🔹 mantiene proporción
                objectFit: "contain"
              }}
            />
          </Link>
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <Link to="/">Inicio</Link>
            </li>
            <li className="dropdown hover-dropdown">
              <a href="#" className="dropdown-toggle">
                Cómo comprar <span className="caret"></span>
              </a>
              <ul className="dropdown-menu">
                <li>
                  <Link to="/address-of-use">DIRECCIÓN DE USA</Link>
                </li>
                <li>
                  <Link to="/exemption-amazon">
                    EXENCIÓN DE IMPUESTOS AMAZON
                  </Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to="/about">Nosotros</Link>
            </li>
            <li>
              <Link to="/news">Noticias</Link>
            </li>
            <li>
              <Link to="/contact">Contacto</Link>
            </li>
            <li>
              <a
                href="https://app.airbox.pe/login"
                target="_self"
                rel="noopener noreferrer"
                className="custom-login-link"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  fontWeight: "bold",
                  color: "#2563eb",
                  position: "relative", // necesario para que el :after funcione correctamente
                }}
              >
                <i className="fa fa-sign-in" />
                Iniciar sesión
              </a>
            </li>

            <li>
              <a
                href="https://app.airbox.pe/register"
                target="_self"
                rel="noopener noreferrer"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "2px",
                  fontWeight: "bold",
                  color: "#f87115",
                }}
              >
                <i className="fa fa-user-plus" />
                Regístrate
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
